import React from 'react';
import { Route, Routes } from "react-router-dom";
import HomeScreen from "../screens/HomeScreen";
import Login from "../screens/Login";
import ProtectedRoute from "./components/ProtectedRoutet";
import HomeScreenNew from "../screens/HomeScreenNew";
import BillingData from "../screens/BillingData";

const Navigation = () => {
    return (
        <Routes>
            <Route path="*" element={<Login />} />
            <Route path="/login" element={<Login />} />
            <Route path="/home" element={
                <ProtectedRoute>
                    <HomeScreenNew />
                </ProtectedRoute>
            } />
            <Route path="/home-old" element={
                <ProtectedRoute>
                    <HomeScreen />
                </ProtectedRoute>
            } />
            <Route path="/billing-data" element={
                <ProtectedRoute>
                    <BillingData />
                </ProtectedRoute>
            } />
        </Routes>
    );
};

export default Navigation;
